import { ICustomField, IEntity } from '@pf/shared-common';
import {
    EquipmentSearchRequestParams,
    EquipmentStatus,
    EquipmentTypeFragment,
    EquipmentViewModelCreateBody,
    EquipmentViewModelRead,
    ResourceAuth,
    WarehouseFragment,
    ZoneFragment,
} from '@control-tower/platform-wms';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { IUserFragment, NoteDto } from '@pf/shared/util-platform';
import { ContainerDto } from './container.dto';
import { StatusOptions } from '@pf/shared-ui';

export type EquipmentRead = EquipmentViewModelRead & IEntity;
export type EquipmentCreate = EquipmentViewModelCreateBody;
export type EquipmentSearchParams = EquipmentSearchRequestParams;

export class EquipmentDto implements IWarehouseEntity {
    constructor(data: Partial<EquipmentDto>) {
        Object.assign(this, data);
    }
    id!: string;
    warehouse!: WarehouseFragment;
    equipmentType!: EquipmentTypeFragment;
    barcode?: string | null;
    name?: string | null;
    description?: string | null;
    status?: EquipmentStatus;
    assignedToUser?: IUserFragment;
    notes?: Array<NoteDto> | null;
    lastMaintenanceDate?: string | null;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    resourceAuth?: ResourceAuth;
    customFields?: ICustomField[] | null;
    containers?: ContainerDto[] | null;
    zone?: ZoneFragment | null;
}

export const EquipmentStatusOptions: StatusOptions = {
    [EquipmentStatus.Staged]: {
        label: 'Staged',
        color: '#5CB85C', // Green
    },
    [EquipmentStatus.Available]: {
        label: 'Available',
        color: '#5faff3', // Light Blue
    },
    [EquipmentStatus.InUse]: {
        label: 'In Use',
        color: '#8BC34A', // Light Green
    },
    [EquipmentStatus.Maintenance]: {
        label: 'Maintenance',
        color: '#4CAF50', // Darker Green
    },
    [EquipmentStatus.Retired]: {
        label: 'Archived',
        color: '#9E9E9E', // Grey
    },
    [EquipmentStatus.OutOfService]: {
        label: 'Out of Service',
        color: '#D9534F', // Red
    },
    defaultOption: {
        label: 'Unknown',
        color: '#808080', // Standard Grey
    },
};
